export const consoleAndThrow = newMessage => {
  console.error(newMessage)
  throw Error(newMessage)
}
export const capitalize = key => {
  return key.charAt(0).toUpperCase() + key.slice(1)
}
